import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { RegisterTrade } from 'C4';

// TODO add password fields
// TO CHECK: Las Vegas (Firebase login)
const Register = (props) => (
  <div className="RegisterHolder">
    <h4 className="subtop">{i18n.translate('loginScreen.header')}</h4>
    {window.location.pathname !== '/exhibitor' && <div className="step">{i18n.translate('loginScreen.step1')}</div>}
    <RegisterTrade
      passwordField={props.passwordField}
      back={props.back}
      submit={props.submit}
      change={props.change}
      loadingAnimRegister={props.loadingAnimRegister}
      country={props.country}
      data={props.data}
    />
  </div>
);

export default Register;

Register.propTypes = {
  passwordField: PropTypes.bool,
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  country: PropTypes.string,
};

Register.defaultProps = {
  defaultVal: '',
  passwordField: false,
  country: '',
};
